import {
  MINIAPP_ACCOUNTS_REQUEST,
  MINIAPP_ACCOUNTS_FAILURE,
  FETCH_MINIAPP_ACCOUNTS_SUCCESS,
  FETCH_MINIAPP_ACCOUNT_AREAS_SUCCESS,
  CREATE_MINIAPP_ACCOUNT_SUCCESS,
  UPDATE_MINIAPP_ACCOUNT_SUCCESS,
  DELETE_MINIAPP_ACCOUNT_SUCCESS,
  GET_MINIAPP_ACCOUNT_SUCCESS,
  FETCH_STATISTICS_BY_AREA_SUCCESS,
} from "../action/types";

const initialState = {
  miniappAccounts: [],
  areas: [],
  total: 0,
  currentMiniappAccount: null,
  loading: false,
  error: null,
  statisticsByArea: [],
  followedOACount: 0,
  followedOAVerifiedCount: 0,
  totalCount: 0,
};

const miniappAccountsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case MINIAPP_ACCOUNTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_MINIAPP_ACCOUNTS_SUCCESS: {
      const data = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload)
          ? payload
          : [];
      return {
        ...state,
        loading: false,
        miniappAccounts: data,
        total: payload?.total ?? data.length,
      };
    }

    case FETCH_MINIAPP_ACCOUNT_AREAS_SUCCESS:
      return {
        ...state,
        areas: Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload)
            ? payload
            : [],
      };

    case FETCH_STATISTICS_BY_AREA_SUCCESS:
      return {
        ...state,
        loading: false,
        statisticsByArea: Array.isArray(payload?.byArea)
          ? payload.byArea
          : Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload)
              ? payload
              : [],
        followedOACount: payload?.followedOACount ?? 0,
        followedOAVerifiedCount: payload?.followedOAVerifiedCount ?? 0,
        totalCount: payload?.totalCount ?? 0,
      };

    case GET_MINIAPP_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        currentMiniappAccount: payload,
      };

    case CREATE_MINIAPP_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        miniappAccounts: [payload, ...state.miniappAccounts],
        total: state.total + 1,
      };

    case UPDATE_MINIAPP_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        miniappAccounts: state.miniappAccounts.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case DELETE_MINIAPP_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        miniappAccounts: state.miniappAccounts.filter(
          (item) => item.id !== payload,
        ),
        total: Math.max(0, state.total - 1),
      };

    case MINIAPP_ACCOUNTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default miniappAccountsReducer;
